import type { SportType } from '@/types';
import { getSportOption } from '@/utils/sports';

export type TournamentListTab = 'all' | 'ongoing' | 'upcoming' | 'completed' | 'draft';
export type TournamentListStatus = Exclude<TournamentListTab, 'all'>;

export const TOURNAMENT_LIST_TAB_LABELS: Record<TournamentListStatus, string> = {
  ongoing: 'Идут',
  upcoming: 'Скоро',
  completed: 'Завершенные',
  draft: 'Черновики',
};

const STATUS_VALUES = new Set<string>(Object.keys(TOURNAMENT_LIST_TAB_LABELS));

export type TournamentListFilters = {
  sportType?: SportType;
  status?: TournamentListStatus;
};

export function parseTournamentListSearch(search: URLSearchParams): TournamentListFilters {
  const rawStatus = search.get('status') ?? '';
  const rawSport = search.get('sportType') ?? '';
  const sportType = getSportOption(rawSport as SportType) ? (rawSport as SportType) : undefined;
  const status = STATUS_VALUES.has(rawStatus) ? (rawStatus as TournamentListStatus) : undefined;
  return { sportType, status };
}

export function serializeTournamentListSearch(filters: TournamentListFilters): URLSearchParams {
  const params = new URLSearchParams();
  if (filters.sportType) params.set('sportType', filters.sportType);
  if (filters.status) params.set('status', filters.status);
  return params;
}

export function tournamentListPath(filters: TournamentListFilters): string {
  const params = serializeTournamentListSearch(filters);
  const query = params.toString();
  return query ? `/tournaments?${query}` : '/tournaments';
}

export function tournamentListHeadingSuffix(filters: TournamentListFilters): string {
  return [
    filters.sportType ? getSportOption(filters.sportType)?.label : undefined,
    filters.status ? TOURNAMENT_LIST_TAB_LABELS[filters.status] : undefined,
  ]
    .filter(Boolean)
    .join(' · ');
}
